export { newsApi } from './newsApi';
export { NEWS_ROUTES } from './routes';
export type {
  CreateNewsDto,
  NewsDetailDto,
  NewsListItemDto,
  NewsListParams,
  NewsListResponseDto,
  UpdateNewsDto,
} from './types';
